export const endpoint = {
  user: 'user/search',
  role: 'role/search',
  userType: 'user/userType/options',
  userGroup: 'user/usergroup/all/options',
  unit: 'user/unit/options',
  location: 'user/location/options',
  userRole: 'user/role/all/options',
  responsibleForUnit: 'user/unit/options',
  accessToScreen: 'user/accesstoscreen/screen/options',
  roleAccessToOperation: 'role/operationaccess/operation/options',
  userAccessToOperation: 'user/operationaccess/operation/options',
  userApplication: 'user/application/options',
  roleApplication: 'role/operationaccess/application/all/options',
  caseType: 'user/casetype/options',
  userExportToExcel: 'user/export/excel',
  roleExportToExcel: 'role/export/excel',
  visibleForFields: 'user/personOptionsCollection/fieldNodes',
  extraInfo: 'user/extraInfo/fields/options',
  defaultValues: {
    optionList: 'user/defaultValues/optionsCollections/all/options',
    applications: 'user/defaultValues/caseTypes/all/options',
    defaultValues: 'user/defaultValues/optionsCollection/{0}/all/options',
    domains: 'user/defaultValues/optionsCollection/{0}/fields/all/options'
  },
  experienceTransferAlerts: 'user/subscription/options'
};
